import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

export default function ProductImages(props) {
  const { images, onClick } = props;

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getYouTubeId = (url) => {
    // const regExp =
    //   /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    // const match = url?.match(regExp);
    // return match ? match[1] : null;

    const regExp =
      /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (!match) return null;
    const videoId = match.find((part) => part && part.length === 11);

    return videoId || null;
  };

  return (
    <Slider {...settings}>
      {images?.map((val, i) => (
        <div key={i}>
          {val?.type?.toLowerCase() === "video" && (
            <video controls className="product-details-video">
              <source src={val?.url} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          )}

          {val?.type?.toLowerCase() === "youtube" && (
            <iframe
              className="product-details-video"
              src={`https://www.youtube.com/embed/${getYouTubeId(val?.url)}`}
              title="YouTube video player"
              // allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}

          {val?.type?.toLowerCase() !== "video" &&
            val?.type?.toLowerCase() !== "youtube" && (
              <img
                src={val?.url}
                alt=""
                className="product-details-img"
                onClick={() => onClick(val)}
              />
            )}
        </div>
      ))}
    </Slider>

    // <Slider {...settings}>
    //   {images?.map((val, i) => (
    //     <a
    //       key={i}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //       onClick={() => onClick(val)}
    //     >
    //       {val?.type === "video" ? (
    //         <video controls className="product-details-video">
    //           <source src={val?.url} type="video/mp4" />
    //           Your browser does not support the video tag.
    //         </video>
    //       ) : (
    //         <img src={val?.url} alt="" className="product-details-img" />
    //       )}
    //     </a>
    //   ))}
    // </Slider>
  );
}
